import { useEffect, useState } from "react";
import { Close } from "@mui/icons-material";
import SendIcon from "@mui/icons-material/Send";
import {
  Avatar,
  Card,
  CardContent,
  Chip,
  CircularProgress,
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  Modal,
  Radio,
  RadioGroup,
  Stack,
  TextField,
  Typography
} from "@mui/material";
import dayjs from "dayjs";
import moment from "moment";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Getrequestcall } from "../../request/Getrequest";
import { Postrequestcall } from "../../request/Postrequest";
import { BIGrey } from "../../assets/helpers";
import Loader from "../../common/Loader";
import PictureViewer from "../../common/PictureViewer";
import {
  FETCH_CLIENT_ACTIONS,
  FETCH_SAR_ACTION_HISTORY_2,
  SAVE_CLIENT_SAR_ACTIONS_HISTORY,
  SAVE_DUE_CLIENT_SAR_ACTION_HISTORY
} from "../../constant/Apipath";
import {
  BIBlack,
  BIGreen,
  BILightGreen,
  BILightGrey,
  BILightRed,
  BILightYellow,
  BIRed
} from "../../assets/helpers";
import { ClientEnglishFallback } from "../constant/ClientEnglishFallback";
import ClientChangeStatusModal from "./ClientChangeStatusModal";

export default function ClientActionsDetails() {
  const { loginData, selectedClientData, multiLanguageData } = useSelector((state) => state?.main);
  const location = useLocation();
  const { aid: id } = useParams();
  let lastStatus = "";
  const nav = useNavigate();
  const currentTab = location.state?.currentTab;

  const [actionDetails, setActionDetails] = useState();
  const [openStatusModal, setOpenStatusModal] = useState(false);
  const [commentText, setComment] = useState("");
  const [buttonLoading, setButtonLoading] = useState(false);
  const [checked, setChecked] = useState(0);
  const [loader, setLoader] = useState(false);
  const [sarHistoryLoader, setSARHistoryLoader] = useState(false);
  const [index, setIndex] = useState(null);
  const [pictureView, setPictureView] = useState(false);
  const [SARHistory, setSARHistory] = useState([]);

  const {
    TEXT_CREATED_BY,
    TEXT_CREATED_FOR,
    TEXT_DUE,
    TEXT_STATUS,
    TEXT_UPDATE,
    TEXT_CREATED_ON,
    TEXT_WRITE_COMMENT,
    TEXT_UPDATE_STATUS,
    TEXT_INPROGRESS,
    TEXT_ONHOLD,
    TEXT_COMPLETED
  } = ClientEnglishFallback?.ActionDetails(multiLanguageData?.ActionDetails || {});

  useEffect(() => {
    if (id) {
      fetchActionsdata();
    } else {
      nav("../actions");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchActionsdata = async () => {
    try {
      setLoader(true);
      let obj = {
        PageNr: 1,
        NrOfRecPerPage: 100,
        FullSearch: "",
        UserId: loginData?.userInformation?.UserId,
        IncludeRecordNr: true,
        FetchAllowedRecordsOnly: true,
        SortList: [
          {
            FieldName: "Id",
            Direction: "DESC"
          }
        ],
        SearchList: [{ id: id }]
      };
      let getActions = await Postrequestcall(FETCH_CLIENT_ACTIONS, obj, loginData?.accessToken);
      setActionDetails(getActions?.data?.data[0]);
      await getApiCAll(getActions?.data?.data[0].id, loginData?.userInformation?.UserId);
      const status = getActions?.data?.data[0].status;

      let checkedValue;
      switch (status) {
        case "":
          checkedValue = 0;
          break;
        case "In Progress":
          checkedValue = 1;
          break;
        case "On Hold":
          checkedValue = 2;
          break;
        case "Completed":
          checkedValue = 3;
          break;
        case "Overdue":
          checkedValue = 4;
          break;
        default:
          checkedValue = 0;
      }

      setChecked(checkedValue);

      setLoader(false);
    } catch (error) {
      console.log("fetchActionsdata-> Error When Getting Actions Data: ", error);
    }
  };

  // // !this api should be compulsary called after  the above the api

  const getApiCAll = async (clientSARActionId, userId) => {
    await Getrequestcall(
      `${SAVE_DUE_CLIENT_SAR_ACTION_HISTORY}/${clientSARActionId}/${userId}`,
      loginData?.accessToken
    );

    fetchSARHistory();
  };

  const fetchSARHistory = async () => {
    setSARHistoryLoader(true);
    try {
      let obj = {
        PageNr: 1,
        NrOfRecPerPage: 20,
        FullSearch: "",
        UserId: loginData?.userInformation?.UserId,
        IncludeRecordNr: true,
        FetchAllowedRecordsOnly: true,
        SearchList: [{ sarActionId: id }]
      };

      const res = await Postrequestcall(FETCH_SAR_ACTION_HISTORY_2, obj, loginData?.accessToken);
      let status = res?.data?.data[0].status;
      setSARHistory(res?.data?.data);
    } catch (error) {
      console.log("fetchSARHistory-> Error When Getting SAR History: ", error);
    } finally {
      setSARHistoryLoader(false);
    }
  };

  // !for adding comment to the action
  const saveAction = async (comment) => {
    setButtonLoading(true);
    try {
      let obj = {
        UserId: loginData?.userInformation?.UserId,
        ReturnRecordId: true,
        ReturnRecordError: true,

        SaveList: [
          {
            Id: 0,
            SARActionId: actionDetails?.id,
            Status:
              checked === 0
                ? "Not Started"
                : checked === 1
                  ? "In Progress"
                  : checked === 2
                    ? "On Hold"
                    : checked === 3
                      ? "Completed"
                      : "Not Started",
            StatusChangedBy: loginData?.userInformation?.UserId,
            StatusChangedDate: moment(new Date()).format("YYYY-MM-DD"),
            Comment: comment ? commentText : "",
            ModifiedBy: loginData?.userInformation?.UserId
          }
        ]
      };
      await Postrequestcall(SAVE_CLIENT_SAR_ACTIONS_HISTORY, obj, loginData?.accessToken);
      await fetchActionsdata();
      setButtonLoading(false);
      setComment("");
    } catch (error) {
      setButtonLoading(false);
      console.log("saveAction-> Error When Saving Action: ", error);
    }
  };

  // ! for updating the status of the action
  const upadteActionStatus = async (key) => {
    setOpenStatusModal(false);
    try {
      let obj = {
        UserId: loginData?.userInformation?.UserId,
        ReturnRecordId: true,
        ReturnRecordError: true,

        SaveList: [
          {
            Id: 0,
            SARActionId: actionDetails?.id,
            Status:
              key === 0
                ? "Not Started"
                : key === 1
                  ? "In Progress"
                  : key === 2
                    ? "On Hold"
                    : key === 3
                      ? "Completed"
                      : "Not Started",
            StatusChangedBy: loginData?.userInformation?.UserId,
            StatusChangedDate: moment(new Date()).format("YYYY-MM-DD"),
            Comment: "",
            ModifiedBy: loginData?.userInformation?.UserId
          }
        ]
      };

      await Postrequestcall(SAVE_CLIENT_SAR_ACTIONS_HISTORY, obj, loginData?.accessToken);

      fetchActionsdata();

      setButtonLoading(false);
      setComment("");
    } catch (error) {
      setButtonLoading(false);
      console.log("upadteActionStatus-> Error When Updating Action Status: ", error);
    }
  };

  const handleStatusModal = () => {
    setOpenStatusModal(true);
  };

  return (
    <>
      <PictureViewer
        isOpen={pictureView}
        onClose={() => setPictureView(false)}
        pictures={actionDetails?.pictureList?.map((item, i) => {
          return { src: item?.fileUrl };
        })}
        viewerIndex={index}
      />
      {loader ? (
        <Loader fullScreen={true} />
      ) : (
        <Card>
          <Stack sx={{ p: 2 }}>
            <Stack>
              <Typography style={{ color: BIGrey, fontSize: "14px" }}>
                {currentTab !== "Submitted" ? TEXT_CREATED_BY : TEXT_CREATED_FOR}
              </Typography>
              <Stack sx={{ display: "flex", justifyContent: "space-between" }} direction={"row"}>
                <Stack direction={"row"} sx={{ alignItems: "center" }}>
                  <Avatar
                    src={
                      actionDetails?.employeeId !== selectedClientData?.ClientEmployeeId
                        ? actionDetails?.employeeProfilePicture
                        : actionDetails?.userProfilePicture
                    }
                    alt={actionDetails?.userName}
                    style={{ width: 40, height: 40 }} // Adjust size as needed
                  />
                  <Typography
                    style={{
                      fontSize: "14px",
                      marginLeft: "8px"
                    }}>
                    {actionDetails?.employeeId !== selectedClientData?.ClientEmployeeId
                      ? actionDetails?.employeeName
                      : actionDetails?.userName}
                  </Typography>
                </Stack>
                <Stack>
                  <Typography style={{ color: BIGrey }}> {TEXT_DUE}</Typography>
                  <Typography>{`${dayjs(actionDetails?.dueDate).format(
                    "MMMM DD, YYYY "
                  )}`}</Typography>
                </Stack>
              </Stack>
            </Stack>
          </Stack>

          <Stack sx={{ p: 2 }}>
            <Grid container sx={{ alignItems: "center" }}>
              <Grid>
                <Typography variant="body1">{actionDetails?.title}</Typography>
              </Grid>
            </Grid>
            <Typography variant="body2" style={{ marginTop: "10px" }} sx={{ color: "text.secondary" }}>
              {actionDetails?.description}
            </Typography>
            <div
              style={{
                display: "flex",
                gap: "10px",
                overflow: "auto",
                marginTop: "10px"
              }}>
              {actionDetails?.pictureList != null &&
                actionDetails?.pictureList?.length > 0 &&
                actionDetails?.pictureList?.map((item, index) => {
                  return (
                    <div
                      key={index}
                      style={{
                        display: "flex",
                        gap: "10px",
                        marginBottom: "10px"
                      }}>
                      <img
                        loading="lazy"
                        onClick={() => {
                          setIndex(index);
                          setPictureView(true);
                        }}
                        src={item.fileUrl}
                        alt="img"
                        style={{
                          width: "100px",
                          height: "100px",
                          borderRadius: "10px"
                        }}
                      />
                    </div>
                  );
                })}
            </div>
            <Typography style={{ color: BIGrey }}>{TEXT_STATUS}</Typography>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px"
              }}>
              <Chip
                label={actionDetails?.status}
                style={
                  actionDetails?.status === "In Progress"
                    ? {
                        backgroundColor: BILightYellow,
                        color: "brown"
                      }
                    : actionDetails?.status === "Overdue"
                      ? { backgroundColor: BILightRed, color: BIRed }
                      : actionDetails?.status === "Not Started"
                        ? {
                            backgroundColor: BILightGrey,
                            color: BIBlack
                          }
                        : actionDetails?.status === "On Hold"
                          ? {
                              backgroundColor: "pink",
                              color: "brown"
                            }
                          : {
                              backgroundColor: BILightGreen,
                              color: BIGreen
                            }
                }
              />
              {actionDetails?.status !== "Overdue" &&
                actionDetails?.employeeId === selectedClientData?.ClientEmployeeId &&
                currentTab !== "Submitted" && (
                  <p
                    style={{
                      cursor: "pointer",
                      color: selectedClientData?.AccentColor
                    }}
                    onClick={() => handleStatusModal()}>
                    {TEXT_UPDATE}
                  </p>
                )}
            </div>
          </Stack>

          <Divider style={{ marginTop: "10px" }} />

          <Typography
            sx={{ textAlign: "center" }}
            style={{
              color: BIGrey,
              width: "100%"
            }}>
            {TEXT_CREATED_ON} {moment(actionDetails?.dateCreated).format("MMMM D, YYYY, h:mm a")}
          </Typography>
          {sarHistoryLoader ? (
            <Loader />
          ) : (
            <Stack sx={{ p: 2 }}>
              <>
                {SARHistory?.map((item, index) => {
                  const shouldDisplayStatus =
                    item.status !== "Overdue" &&
                    item.status !== "Not Started" &&
                    item.status !== lastStatus;

                  if (shouldDisplayStatus) {
                    lastStatus = item.status;
                  }
                  return (
                    <div key={index}>
                      {item.status !== "Overdue" && (
                        <>
                          {item.comment !== "" && (
                            <Grid
                              gap={1}
                              container
                              sx={{ marginTop: 2,  alignItems: "center",  justifyContent: "space-between" }}
                              
                              >
                              {item.statusChangedByUser !== "" && (
                                <Grid>
                                  <Avatar
                                    alt={item?.userProfilePicture}
                                    src={item?.userProfilePicture}
                                  />
                                </Grid>
                              )}
                              {item.statusChangedByUser !== "" && (
                                <Grid>
                                  <Typography variant="body2">{item?.statusChangedByUser}</Typography>
                                </Grid>
                              )}

                              {item.statusChangedByUser !== "" && (
                                <Grid sx={{ marginLeft: "auto" }}>
                                  <Typography
                                    variant="body2"
                                    style={{
                                      color: BIGrey
                                    }}>
                                    {moment(item?.statusChangedDate).format("MMMM DD, YYYY")}
                                  </Typography>
                                </Grid>
                              )}
                            </Grid>
                          )}
                        </>
                      )}

                      <Typography variant="body2">{item?.comment} </Typography>

                      {shouldDisplayStatus && (
                        <Typography
                          sx={{ textAlign: "center" }}
                          style={{
                            width: "100%",
                            color: BIGrey
                          }}>
                          {item.status}
                          {" on "}
                          {moment(
                            item?.statusChangedDate !== null
                              ? item?.statusChangedDate
                              : actionDetails?.dueDate
                          ).format("MMMM DD, YYYY")}
                        </Typography>
                      )}
                    </div>
                  );
                })}

                {actionDetails?.employeeId === selectedClientData?.ClientEmployeeId &&
                  checked !== 3 && (
                    <div
                      style={{
                        margin: "10px 0px",
                        display:
                          actionDetails?.status === "Completed" || currentTab === "Submitted"
                            ? "none"
                            : "flex",
                        alignItems: "center",
                        gap: "10px"
                      }}>
                      <TextField
                        variant="standard"
                        value={commentText}
                        onChange={(e) => {
                          let inputValue = e.target.value;
                          inputValue = inputValue.replace(/^[^A-Za-z0-9]+/, "");
                          setComment(inputValue);
                        }}
                        InputProps={{
                          disableUnderline: true
                        }}
                        fullWidth
                        style={{
                          padding: "5px",
                          borderRadius: "10px",
                          backgroundColor: "lightgray",
                          size: "small",
                          marginLeft: "10px"
                        }}
                        placeholder={TEXT_WRITE_COMMENT}
                      />
                      <IconButton
                        disabled={commentText?.length === 0 || buttonLoading}
                        onClick={() => {
                          saveAction("comment");
                        }}>
                        {buttonLoading ? (
                          <CircularProgress
                            size={24}
                            sx={{
                              color:
                                selectedClientData?.AccentColor !== undefined &&
                                selectedClientData?.AccentColor
                                  ? selectedClientData?.AccentColor
                                  : BILightGrey
                            }}
                          />
                        ) : (
                          <SendIcon
                            style={{
                              color:
                                commentText?.length !== 0 ? selectedClientData?.AccentColor : ""
                            }}
                          />
                        )}
                      </IconButton>
                    </div>
                  )}
              </>
            </Stack>
          )}
        </Card>
      )}

      <ClientChangeStatusModal
        selectedClientData={selectedClientData}
        open={openStatusModal}
        close={() => setOpenStatusModal(false)}
        selectedStatus={actionDetails?.status}
        saveStatus={(key) => {
          upadteActionStatus(key);
        }}
        TEXT_UPDATE_STATUS={TEXT_UPDATE_STATUS}
        TEXT_INPROGRESS={TEXT_INPROGRESS}
        TEXT_ONHOLD={TEXT_ONHOLD}
        TEXT_COMPLETED={TEXT_COMPLETED}
      />
    </>
  );
}
